import Vue from 'vue'
import VueRouter from 'vue-router'
import VTooltip from 'v-tooltip'

import store from '@/store'
import { CHECK_AUTH_CLIENT, HANDLE_HIDDEN_NAV_MENU, SET_OPEN_LOGIN_DIALOG } from '@/store/actions.type'
import JwtService from '@/common/jwt.service'
import ApiService from '@/common/api.service'
import { HANDLE_HIDDEN_REGISTER_HEADER } from '../store/actions.type'
import { MessageBox, Message } from 'element-ui'
import { isPathAllowed, isJailOnlyPageAllowed, getSessionViolationMessage, getJailLeaveWarningMessage, ACCOUNT_EXISTS_FLASH_MESSAGE } from './routeGuards'

Vue.use(VueRouter)
Vue.use(VTooltip)
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/pages/client/Index.vue'),
    redirect: 'portal',
    children: [
      {
        path: '/stationTax',
        name: 'stationTax',
        component: () => import('../views/pages/client/10_stationtax/StationTax.vue'),
        meta: {
          requiresAuth: false,
          title: '10秒でわかる相続税 | 税理士法人レガシィ',
          metaTags: [
              {
                  name: 'description',
                  content: 'お住いの最寄駅を選択いただくだけで相続税額をお出しします。一軒家・地主・大地主というパターンから、相続税額がどの程度かといった参考にお使いください。'
              },
              {
                  name: 'keywords',
                  content: 'レガシィ,相続,相続税,手続き,申告,10秒,最寄駅,一軒家,地主,大地主'
              }
          ]
        }
      },
      {
        path: '/category',
        name: 'category',
        component: () => import('../views/pages/client/11_knowhow/KnowHowOverview.vue'),
        meta: {
          requiresAuth: false,
          title: '読んでわかる相続 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '難しいイメージのある相続をわかりやすい読み物にしました。お気軽にお読みいただける内容でお届けしております。読んでいただければ相続がわかります。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告'
                }
            ]
        }
      },
      {
        path: '/categoryDetail/:id',
        name: 'categoryDetail',
        component: () => import('../views/pages/client/11_knowhow/KnowHowDetail.vue'),
        meta: {
          requiresAuth: false,
          title: '読んでわかる相続税詳細 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '難しいイメージのある相続をわかりやすい読み物にしました。お気軽にお読みいただける内容でお届けしております。読んでいただければ相続がわかります。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告'
                }
            ]
        }
      },
      {
        path: '/anken',
        name: 'anken',
        component: () => import('../views/pages/client/38_anken/Anken.vue'),
        meta: {
          requiresAuth: true,
          title: 'ご依頼一覧 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '案件の進捗状況や依頼内容をご確認いただけます。税理士法人レガシィへ依頼していただいたすべての案件情報を確認できます。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,相続発生,案件情報'
                }
            ]
        }
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import('../views/pages/client/ContactUs.vue'),
        meta: {
          requiresAuth: false,
          title: '問い合わせ | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続に関する疑問や質問・業務依頼を受け付けております。お気軽に、税理士法人レガシィへのお問い合わせください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,問合せ,相談,質問'
                }
            ]
        }
      },
      {
        path: '/invoiceFlag/:id',
        name: 'invoiceFlag',
        component: () => import('../views/pages/client/6_invoice_flag/InvoiceFlag.vue'),
        meta: {
          requiresAuth: true,
          title: '相続手続きチェックリスト | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続手続き作業をわかりやすいチェックリストにしました。相続税申告までの手続きだけでなく、相続税申告後の申請手続き等まで、相続手続きを網羅したチェックリストです。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,手続き,チェックリスト,やる事,期限,死亡届,健康保険,年金,相続放棄,準確定申告,相続税申告,高額医療費'
                }
            ]
        }
      },
      {
        path: '/invoiceFlag',
        name: 'globalInvoiceFlag',
        component: () => import('../views/pages/client/6_invoice_flag/InvoiceFlag.vue'),
        meta: {
          requiresAuth: false,
          title: '相続手続きチェックリスト | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続手続き作業をわかりやすいチェックリストにしました。相続税申告までの手続きだけでなく、相続税申告後の申請手続き等まで、相続手続きを網羅したチェックリストです。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,手続き,チェックリスト,やる事,期限,死亡届,健康保険,年金,相続放棄,準確定申告,相続税申告,高額医療費'
                }
            ]
        }
      },
      {
        path: '/seminar',
        name: 'seminar',
        component: () => import('../views/pages/client/4_seminar/Seminar.vue'),
        meta: {
          requiresAuth: false,
          title: 'セミナー案内 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '税理士法人レガシィでは定期的に無料セミナーを開催しています。会員制サイト「相続のせんせい」の会員向けの無料セミナーです。お気軽にご参加ください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,セミナー案内,セミナー申し込み,無料セミナー,相続,相続税,遺族,サポートフェア,八重洲,東京ミッドタウン八重洲'
                }
            ]
        }
      },
      {
        path: '/seminar/:id/join',
        name: 'seminarJoin',
        component: () => import('../views/pages/client/4_seminar/SeminarJoin.vue'),
        meta: {
          requiresAuth: true,
          title: 'セミナー参加 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '税理士法人レガシィでは定期的に無料セミナーを開催しています。会員制サイト「相続のせんせい」の会員向けの無料セミナーです。お気軽にご参加ください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,セミナー案内,セミナー申し込み,無料セミナー,相続,相続税,遺族,サポートフェア,八重洲,東京ミッドタウン八重洲'
                }
            ]
        }
      },
      {
        path: '/document/:id',
        name: 'document',
        component: () => import('../views/pages/client/7_document/Document.vue'),
        meta: {
          requiresAuth: true,
          title: '相続税申告スケジュール | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続税申告プランに沿ったスケジュールをご提示します。税理士法人レガシィは、お客様ひとりひとりの相続状況に応じた最適な相続税申告プランをご提供します。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,スケジュール,期限'
                }
            ]
        }
      },
      {
        path: '/estimation/:id',
        name: 'estimation',
        component: () => import('../views/pages/client/20_estimation/Estimation.vue'),
        meta: {
          requiresAuth: true,
          title: '報告書 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'ご依頼された業務の報告書をご確認いただけます。税理士法人レガシィでは、ご契約前に提案書・見積書を作成し、対応方法と報酬金額を明確にしております。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,報告書'
                }
            ]
        }
      },
      {
        path: '/member/register',
        name: 'memberRegister',
        component: () => import('../views/pages/client/31_member/MemberRegister'),
        meta: {
          requiresAuth: false,
          title: '会員登録 | 税理士法人レガシィ',
          hiddenNavMenu: true,
          hiddenRegisterHeader: true,
            metaTags: [
                {
                    name: 'description',
                    content: '「相続のせんせい」は会員サイトです。会員になっていただくことで、相続に関する経験が豊富な税理士法人レガシィから、有益な情報をお届けします。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,せんせい,相続税,手続き,申告,遺産,会員,情報'
                }
            ]
        }
      },
      {
          path: '/heritageDivision/:id',
          name: 'heritageDivision',
          component: () => import('../views/pages/client/16_heritagedivision/HeritageDivisionPage'),
          meta: {
              requiresAuth: true,
              title: '遺産分割シミュレーション | 税理士法人レガシィ',
              metaTags: [
                  {
                      name: 'description',
                      content: '実際の遺産価額から遺産分割のシミュレーションができます。ご自身でいくつかの遺産分割パターンを作成して検討することで、納得のいく遺産分割を実現します。'
                  },
                  {
                      name: 'keywords',
                      content: 'レガシィ,相続,相続税,手続き,申告,遺産,遺産分割,シミュレーション'
                  }
              ]
          }
      },
      {
        path: '/camera/:id',
        name: 'camera',
        component: () => import('../views/pages/client/13_camera/Camera'),
        meta: {
            requiresAuth: true,
            title: 'スマホで書類提供 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'スマートフォンから相続手続きで必要な書類をアップロードしてください。必要書類を撮影してアップロードするだけで、郵送などの書類のやりとりが不要となり、スムーズな相続手続きが可能になります。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,スマートフォン,書類,提供'
                }
            ]
        }
      },
      {
        path: '/diagnosis',
        name: 'diagnosis',
        component: () => import('../views/pages/client/8_diagnosis/Diagnosis'),
        meta: {
          requiresAuth: false,
          title: '相続モメ度診断 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '質問に答えるだけで、相続でモメる可能性を診断できます。相続はモメるのか。それはお客様の環境次第です。レガシィの経験からモメる可能性をはじき出します。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,モメ,診断,質問'
                }
            ]
        }
      },
      {
        path: '/calculation/tax',
        name: 'calculationTax',
        component: () => import('../views/pages/client/5_calculationtax/CalculationTax'),
        meta: {
            requiresAuth: false,
            title: '相続税かんたん計算 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '資産情報を入力するだけで、相続税額を簡単に計算できます。さらに、税理士法人レガシィへ業務を依頼した場合の報酬額も計算できるので、相続にかかる費用がすべてわかります。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,対策,資産,計算,報酬,業務,依頼'
                }
            ]
        }
      },
      {
        path: '/survey',
        name: 'CustomerSurvey',
        component: () => import('../views/pages/client/18_survey/CustomerSurvey'),
        meta: {
          requiresAuth: false,
          title: 'アンケート | 税理士法人レガシィ',
          hiddenNavMenu: true,
            metaTags: [
                {
                    name: 'description',
                    content: 'サービス向上のためにアンケートの入力にご協力ください。いただいたご要望・ご意見を真摯に受け止め、より充実したサービス提供に努めてまいります。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,アンケート'
                }
            ]
        }
      },
      {
        path: '/life-event',
        name: 'chronology',
        component: () => import('../views/pages/client/9_life_event/Chronology'),
        meta: {
          requiresAuth: true,
          title: 'My家族年表 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'ご家族のイベント年表を作成して節税対策ができます。イベントごとに節税ノウハウをご提供しますので、ご家族のイベント管理と節税対策にご利用ください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,イベント,年表,節税,ノウハウ'
                }
            ]
        }
      },
      {
        path: '/edit-life-event',
        name: 'editChronology',
        component: () => import('../views/pages/client/9_life_event/EditChronology'),
        meta: {
          requiresAuth: true,
          title: 'My家族年表 | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'ご家族のイベント年表を作成して節税対策ができます。イベントごとに節税ノウハウをご提供しますので、ご家族のイベント管理と節税対策にご利用ください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,イベント,年表,節税,ノウハウ'
                }
            ]
        }
      },
      {
        path: '/download',
        name: 'download',
        component: () => import('../views/pages/client/download/Download'),
        meta: {
          title: '資料ダウンロード | 税理士法人レガシィ',
          metaTags: [
            {
              name: 'description',
              content: ''
            },
            {
              name: 'keywords',
              content: ''
            }
          ]
        }
      },
      {
        path: '/change-password/:loginId/:time/:iv',
        name: 'changePassword',
        component: () => import('../views/pages/client/login/ChangePassword'),
        meta: {
          requiresAuth: false,
          title: 'パスワード変更 | 税理士法人レガシィ',
          hiddenNavMenu: true
        }
      },
      {
        path: '/portal',
        name: 'portal',
        component: () => import('../views/pages/client/portal/Portal'),
        meta: {
          requiresAuth: false,
          title: '相続のせんせい | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続の【難しい】を【かんたん】にする『相続のせんせい』です。相続専門の税理士法人レガシィが監修しており、相続手続きや相続税申告対応だけでなく、相続に対する悩みや不安を解決する機能が満載です。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,せんせい,相続税,手続き,申告,遺産,先生'
                }
            ]
        }
      },
      {
        path: '/portal-member',
        name: 'portalMember',
        component: () => import('../views/pages/client/portal/PortalAuthenticate'),
        meta: {
          requiresAuth: true,
          title: '相続のせんせい | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '相続の【難しい】を【かんたん】にする『相続のせんせい』です。相続専門の税理士法人レガシィが監修しており、相続手続きや相続税申告対応だけでなく、相続に対する悩みや不安を解決する機能が満載です。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,せんせい,相続税,手続き,申告,遺産,先生'
                }
            ]
        }
      },
      {
        path: '/chat/:ankenId',
        name: 'chat',
        component: () => import('../views/pages/client/17_chat/Chat'),
        meta: {
          requiresAuth: true,
          title: 'レガシィほっとライン | 税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '税理士法人レガシィの担当者とチャットができます。お客様のご都合の良いタイミングでレガシィ担当者とチャット形式の情報交換を行うことができます。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,掲示板,チャット,担当者'
                }
            ]
        }
      },
      {
          path: '/termsOfService',
          name: 'termsOfService',
          component: () => import('../views/pages/client/89_termsofservice/TermsOfService'),
          meta: {
              requiresAuth: false,
              title: '利用規約 | 税理士法人レガシィ'
          }
      },
      {
          path: '/accept-terms',
          name: 'acceptTerms',
          component: () => import('../views/pages/client/login/AcceptTerms'),
          meta: {
              requiresAuth: true,
              title: 'ご利用にあたっての同意 | 税理士法人レガシィ'
          }
      },
      {
          path: '/member/identity-verification',
          name: 'identityVerification',
          component: () => import('../views/pages/client/31_member/MemberIdentityVerification'),
          meta: {
              requiresAuth: true,
              title: '本人確認 | 税理士法人レガシィ'
          }
      },
      {
          path: '/privacyPolicy',
          name: 'privacyPolicy',
          beforeEnter () {
            // 元のパスにアクセスされた場合は、下記にリダイレクトを行う
            window.location = 'https://legacy.ne.jp/privacy-customer/'
          },
          component: () => import('../views/pages/client/90_privacypolicy/PrivacyPolicy'),
          meta: {
              requiresAuth: false,
              title: '個人情報保護方針 | 税理士法人レガシィ'
          }
      },
      {
        path: '/member/info',
        name: 'memberInfo',
        component: () => import('../views/pages/client/31_member/MemberInfo'),
        meta: {
          requiresAuth: false,
          title: '会員情報｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '税理士法人レガシィが監修する「相続のせんせい」の会員情報です。会員情報に変更があった場合は、こちらで変更してください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,会員,情報,修正'
                }
            ]
        }
      },
      {
        path: '/search-tax',
        name: 'searchTax',
        component: () => import('../views/pages/client/portal/SearchTax'),
        meta: {
          requiresAuth: false,
          title: '相続税額を調べる｜税理士法人レガシィ'
        }
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('../views/pages/client/login/ResetPassword'),
        meta: {
            requiresAuth: false,
            title: 'パスワード再設定｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'パスワード再設定'
                }
            ]
        }
      },
      {
        path: '/life-event-simulator',
        name: 'demoChronology',
        component: () => import('../views/pages/client/life_event_simulator/DemoChronology'),
        meta: {
          requiresAuth: false,
          title: 'My家族年表｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: 'ご家族のイベント年表を作成して節税対策ができます。イベントごとに節税ノウハウをご提供しますので、ご家族のイベント管理と節税対策にご利用ください。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,相続税,手続き,申告,イベント,年表,節税,ノウハウ'
                }
            ]
        }
      },
      {
        path: '/about-me',
        name: 'aboutMe',
        component: () => import('../views/pages/client/AboutMe'),
        meta: {
          requiresAuth: false,
          title: '「相続のせんせい」とは？｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: '「相続のせんせい」とは、相続のお悩み事を専門家（相続の先生）と解決するためのWebサイトです。どなたでもご利用いただけます。また、会員になっていただくと、より便利な機能をご使用できます。'
                },
                {
                    name: 'keywords',
                    content: 'レガシィ,相続,せんせい,相続税,手続き,申告,遺産,先生'
                }
            ]
        }
      },
        {
            path: '/member/arms-edit',
            name: 'EditMemberArms',
            component: () => import('../views/pages/client/31_member/MemberArmsEdit'),
            meta: {
                requiresAuth: false,
                hiddenNavMenu: true,
                title: '会員登録｜税理士法人レガシィ'
            }
        },
      {
        path: '/messageDetail/:id',
        name: 'messageDetail',
        component: () => import('../views/pages/client/emergency_message_detail/MessageDetail.vue'),
        meta: {
          requiresAuth: false,
          title: 'メッセージ詳細｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: ''
                },
                {
                    name: 'keywords',
                    content: ''
                }
            ]
        }
      },
      {
        path: '/errors/url-expired',
        name: 'urlExpired',
        component: () => import('../views/pages/client/errors/UrlExpired.vue'),
        meta: {
          requiresAuth: false,
          title: 'エラー｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: ''
                },
                {
                    name: 'keywords',
                    content: ''
                }
            ]
        }
      },
      {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import('../views/pages/client/maintenance/Maintenance.vue'),
        meta: {
          requiresAuth: false,
          title: 'メンテナンス中｜税理士法人レガシィ',
            metaTags: [
                {
                    name: 'description',
                    content: ''
                },
                {
                    name: 'keywords',
                    content: ''
                }
            ]
        }
      }
    ]
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: () => import('../views/pages/error-page/404.vue')
  }
]

// True while the "leaving the jail logs you out" confirm is on screen, so a second click
// (or back-button press) during it doesn't stack another dialog.
let jailLeaveConfirmOpen = false

const getRoute = () => {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })

  router.beforeEach((to, from, next) => {
    store.dispatch(HANDLE_HIDDEN_NAV_MENU, !!to.meta.hiddenNavMenu)
    store.dispatch(HANDLE_HIDDEN_REGISTER_HEADER, !!to.meta.hiddenRegisterHeader)
    store.dispatch(CHECK_AUTH_CLIENT).then(() => {
      // Both sessionViolation and accountExists dispatch SET_OPEN_LOGIN_DIALOG here, on the
      // /portal navigation that follows a redirect, rather than at the point the redirect is
      // triggered - CHECK_AUTH_CLIENT (dispatched unconditionally above) resets
      // isOpenLoginDialog to false as a side effect whenever no token is found, which would
      // otherwise immediately clobber a dialog opened before this navigation started.
      if (to.query.sessionViolation) {
        store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
      }
      if (to.query.accountExists) {
        store.dispatch(SET_OPEN_LOGIN_DIALOG, {
          flashMessage: ACCOUNT_EXISTS_FLASH_MESSAGE,
          loginId: to.query.loginId
        })
      }
      // A quarantined (IDENTITY_VERIFICATION_REQUIRED / MIGRATION_REQUIRED) or terms-jailed
      // (TERMS_ACKNOWLEDGEMENT_REQUIRED) session may only reach its own jail's whitelist.
      // The token is destroyed before redirecting, so /portal itself (not on either jail's
      // whitelist) isn't re-blocked by this same check on the follow-up navigation.
      const sessionFlag = JwtService.getSessionFlag()
      // Jail-only pages (/member/identity-verification, /accept-terms) must only render for a
      // session actually holding that page's own jail flag - not for no session at all, and not
      // for an already-ACTIVE one navigating here directly by URL. Silent redirect, matching
      // requiresAuth's own existing "no token" behavior a few lines below, rather than the
      // flash-messaged sessionViolation redirect (that one is for an already-jailed session
      // trying to escape its own jail, a different direction from this check).
      if (!isJailOnlyPageAllowed(to.path, sessionFlag)) {
        return next('/portal')
      }
      if (!isPathAllowed(to.path, sessionFlag)) {
        const logOutOfJail = () => {
          JwtService.destroyAll()
          // destroyAll() only clears the cookie/localStorage, not the shared axios instance's
          // own Authorization default - without clearing that too, the destroyed session's JWT
          // stays attached to every subsequent request, including the next login attempt.
          ApiService.setHeader()
          Message({ message: getSessionViolationMessage(sessionFlag), type: 'warning', duration: 5000 })
          next({ path: '/portal', query: { sessionViolation: '1' } })
        }
        // A fresh page load (typed URL, reload, bookmark) has no screen to stay on, so it logs
        // out immediately as before. Only an in-app navigation (links, menus, browser
        // back/forward) gets the warning first, to prevent accidental logouts (client request).
        if (from.matched.length === 0) {
          return logOutOfJail()
        }
        if (jailLeaveConfirmOpen) {
          return next(false)
        }
        jailLeaveConfirmOpen = true
        return MessageBox.confirm(getJailLeaveWarningMessage(sessionFlag), '確認', {
          confirmButtonText: '移動する',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(
          () => logOutOfJail(),
          // キャンセル, the close button and Esc all stay on the current screen.
          () => next(false)
        ).finally(() => {
          jailLeaveConfirmOpen = false
        })
      }
      // This goes through the matched routes from last to first, finding the closest route with a title.
      const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
      // Find the nearest route element with meta tags.
      const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
      const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
      // If a route with a title was found, set the document (page) title to that value.
      if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title
      } else {
        document.title = previousNearestWithMeta.meta.title
      }
      // Remove any stale meta tags from the document using the key attribute we set below.
      Array.from(document.querySelectorAll('[legacy-meta-tag]')).map(el => el.parentNode.removeChild(el))
      // Skip rendering meta tags if there are none.
      if (!nearestWithMeta) {
          return next()
      }
      // Turn the meta tag definitions into actual elements in the head.
      nearestWithMeta.meta.metaTags.map(tagDef => {
         const tag = document.createElement('meta')
         Object.keys(tagDef).forEach(key => {
             tag.setAttribute(key, tagDef[key])
         })
         // We use this to track which meta tags we create, so we don't interfere with other ones.
         tag.setAttribute('legacy-meta-tag', '')
         return tag
       })
       // Add the meta tags to the document head.
       .forEach(tag => document.head.appendChild(tag))
      if (to.meta.requiresAuth) {
        if (JwtService.getToken()) {
          next()
        } else {
          next('/portal') // TODO: Home screen when no authentication
        }
      } else {
        next()
      }
    })
  })

  router.onError(error => {
    if (/loading chunk chunk-\w* failed./i.test(error.message)) {
      MessageBox({
        title: '最新バージョンを検出したため、リロードを行います。',
        showClose: false,
        center: true
      }, () => { window.location.reload(true) })
    }
  })
  return router
}

export default getRoute
